import {
    DestroyRef,
    Inject,
    Injectable,
    PLATFORM_ID,
    TransferState,
    Optional,
    WritableSignal,
    inject,
    makeStateKey,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    ForgetPasswordRequest,
    LoginRequest,
    SendActivationCodeRequest,
    VerifyActivationCodeRequest,
} from '@core/models/DTOs/authentication.dto';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { AuthRepository } from '@repos/auth.repository';
import { UserProfileRepository } from '../repositories/userProfile.repository';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { WebengageService } from '../webengage.service';
import { CacheService } from '../cache.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { SERVER_COOKIES } from '../../../../../src/app/app.module';

// 👇 این باید قبل از @Injectable باشه
const AUTH_STATE_KEY = makeStateKey<boolean>('isAuthenticated');

@Injectable({ providedIn: 'root' })
export class AuthService {
  _userData: WritableSignal<GetUserProfileResponse | any> = signal(null);
  private destroyRef = inject(DestroyRef);
  private transferState = inject(TransferState);
  _getUserProfileDone = signal(false);
  isPlatformBrowser!: boolean;
  dataUser: any;
  logOutTriggered: WritableSignal<boolean> = signal(false);
  _isAuthenticated: WritableSignal<boolean> = signal(false);
  _isLoadingAuth = signal(true);
  userCuid = signal('');

  authRepo = inject(AuthRepository);

  constructor(
    public userProfileRepo: UserProfileRepository,
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(SERVER_COOKIES) private serverCookies: string[] | null,
    private webengageService: WebengageService
  ) {
    this.isPlatformBrowser = isPlatformBrowser(platformId);
    this.userProfile();
  }

 SendActivationCode(model: SendActivationCodeRequest) {
  return this.authRepo.sendActivationCode(model);
 }
 VerifyActivationCode(model: VerifyActivationCodeRequest) {
  return this.authRepo.verifyActivationCode(model);
 }
 forgetPassword(model: ForgetPasswordRequest) {
  return this.authRepo.forgetPassword(model);
 }
 loginUser(model: LoginRequest) {
  return this.authRepo.login(model);
 }
 userProfile() {
    if (this.isPlatformBrowser) {
      // اگه سرور مقداری transfer کرده، پاکش کن (دیگه لازم نیست)
      if (this.transferState.hasKey(AUTH_STATE_KEY)) {
        this.transferState.remove(AUTH_STATE_KEY);
      }

      let token: any = localStorage.getItem('AccessToken');
      if (token != 'undefined' && token != 'null' && token != null) {
        let decoded: any;
        try {
          decoded = jwtDecode(token);
        } catch {
          this.removeUser();
          return;
        }
        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp != null && decoded.exp <= currentTime) {
          this.removeUser();
        } else {
          this._userData.set(decoded);
          this._isAuthenticated.set(true);
          this._isLoadingAuth.set(false);
          this.logOutTriggered.set(false);
          this.userCuid.set(this._userData());
          const loginEventSent = localStorage.getItem('loginEventSent');
          if (!loginEventSent) {
            this.sendUserLoginEvent();
            localStorage.setItem('loginEventSent', 'true');
          }
        }
      } else {
        this.removeUser();
      }
    } else {
      // SSR: تنها راه فهمیدن لاگین بودن، کوکی سبکی است که هنگام لاگین ست می‌کنیم
      const isLoggedIn = this.getServerCookie('ihoLoggedIn') === '1';
      this._isAuthenticated.set(isLoggedIn);
      this._isLoadingAuth.set(false);
      this.transferState.set(AUTH_STATE_KEY, isLoggedIn);
    }
  }
  private getServerCookie(name: string): string | null {
    if (!this.serverCookies) return null;
    const idx = this.serverCookies.findIndex((h) => h?.toLowerCase() === 'cookie');
    const cookieHeader = idx >= 0 ? this.serverCookies[idx + 1] : '';
    const found = cookieHeader?.split(';').map((c) => c.trim()).find((c) => c.startsWith(name + '='));
    return found ? found.split('=')[1] : null;
  }

  removeUser() {
    if (this.isPlatformBrowser) {
      localStorage.removeItem('AccessToken');
      localStorage.removeItem('RefreshToken');
      localStorage.removeItem('loginEventSent');
      this.document.cookie = 'ihoLoggedIn=; path=/; max-age=0';
    }
    this._userData.set(null);
    this._isLoadingAuth.set(false);
    this._isAuthenticated.set(false);
  }
    getCookie(name: string) {
        if (this.isPlatformBrowser) {
            const value = `; ${this.document.cookie}`;
            const parts: any = value.split(`; ${name}=`);
            if (parts?.length === 2) return parts.pop().split(';').shift();
        }
    }

    getUserData(): WritableSignal<GetUserProfileResponse> {
        return this._userData;
    }

    logOutUser() {
        if (this.isPlatformBrowser) {
            this.logOutTriggered.set(true);
            this.webengageService.inTrackUserLogout();
            const accessToken = localStorage.getItem('AccessToken');
            this.removeUser();
            let logout = this.authRepo.logoutUser(accessToken ?? undefined);
            return logout;
        } else return;
    }

    sendUserLoginEvent() {
        this.webengageService.intrackLogin(this._userData())
    }


    refreshToken(): Observable<any> {
        // Assuming you store the refresh token in local storage
        const refreshToken = localStorage.getItem('RefreshToken');
        return this.userProfileRepo.refreshToken(refreshToken ? refreshToken : '');
    }
    loginasUser(guid: string): Observable<any> {
      return  this.authRepo.loginAsUser(guid);
    }

}
